import { api, defineWebModule } from '@itc/sdk';
import { getNeedsMe, searchBank } from '../shared/endpoints.ts';
import { APPROVALS_TOPIC, meTopic } from '../shared/topics.ts';

// The bank in the shell (design §7.5, plan 2A Chunk 3): the bank page, an entry's
// own page, the approvals queue and what's waiting on you, plus the admin sections
// for accounts, group limits and closing the period. Its settings form comes
// from its schema. On Home, the Bridge's corp bank panel; on the nav, a badge
// counting what's waiting on you (Chunk 6).
export default defineWebModule({
  name: 'bank',
  title: 'Bank',
  search: { permissions: ['bank.view', 'bank.view_ledger'], run: async (q, signal) => (await api(searchBank, { query: { q } }, { signal })).hits },
  routes: [
    { path: '/bank', component: () => import('./pages/BankPage.vue'), meta: { permission: 'bank.view', title: 'Bank' } },
    { path: '/bank/approvals', component: () => import('./pages/Approvals.vue'), meta: { permission: 'bank.approve', title: 'Approvals' } },
    // Open to payees and holders too; the page and the server check.
    { path: '/bank/mine', component: () => import('./pages/Mine.vue'), meta: { permission: 'authenticated', title: 'Waiting on you' } },
    { path: '/bank/entries/:id', component: () => import('./pages/EntryDetail.vue'), meta: { permission: 'authenticated', title: 'Bank entry' } },
  ],
  nav: [
    {
      label: 'Bank',
      to: '/bank',
      permission: 'bank.view',
      icon: 'bank',
      badge: {
        permission: 'authenticated',
        count: async () => (await api(getNeedsMe)).count,
        // What's waiting on you changes on bank.me; for approvers, the queue on bank.approvals.
        topics: (userId, can) => [meTopic(userId), ...(can('bank.approve') ? [APPROVALS_TOPIC] : [])],
        label: (count) => `${String(count)} waiting on you`,
      },
    },
  ],
  widgets: [{ id: 'bank.summary', title: 'Corp bank', permission: 'bank.view', component: () => import('./widgets/BankWidget.vue') }],
  admin: [
    { label: 'Accounts', path: '/admin/bank', component: () => import('./admin/Accounts.vue'), permission: 'bank.admin' },
    { label: 'Group limits', path: '/admin/bank/limits', component: () => import('./admin/GroupLimits.vue'), permission: 'bank.admin' },
    { label: 'Close the period', path: '/admin/bank/periods', component: () => import('./admin/Periods.vue'), permission: 'bank.reconcile' },
  ],
});
